import { render, staticRenderFns } from "./TransactionRefund.vue?vue&type=template&id=0517a45e&scoped=true&"
import script from "./TransactionRefund.vue?vue&type=script&lang=js&"
export * from "./TransactionRefund.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRefund.vue?vue&type=style&index=0&id=0517a45e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0517a45e",
  null
  
)

export default component.exports